/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWorkspaceDto } from '../../models/client-workspace-dto';

export interface ClientWorkspaceControllerFindAll$Params {
}

export function clientWorkspaceControllerFindAll(http: HttpClient, rootUrl: string, params?: ClientWorkspaceControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientWorkspaceDto>>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientWorkspaceDto>>;
    })
  );
}

clientWorkspaceControllerFindAll.PATH = '/api/clientWorkspace/all';
